import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { color } from 'styled-system'

import ctaBackgroundImage from '../../content/images/section_bottom.svg'

const Container = styled.div`
  width: 100%;
  display: flex;
  background-image: url('${ctaBackgroundImage}');
  background-repeat: no-repeat;
  background-position: 90% 100%;
  background-size: cover;
  padding: 8px 0 64px;
  margin-bottom: -5px;

  @media (min-width: 700px) {
    padding: 32px 0 64px;
    background-position: 90% 100%;
  }
`

const Wrapper = styled.section`
  width: 100%;
  min-height: 20vh;
  ${color};
`

const Section = ({ children, withBackground, ...rest }) => {
  return (
    <>
      <Wrapper bg={rest.bg}>
        {children}
        {withBackground && <Container />}
      </Wrapper>
    </>
  )
}

Section.defaultProps = {
  withBackground: false,
}
Section.propTypes = {
  children: PropTypes.element.isRequired,
  withBackground: PropTypes.bool,
}

export default Section
